import { render, staticRenderFns } from "./PriceTest.vue?vue&type=template&id=8122b2dc&scoped=true&"
import script from "./PriceTest.vue?vue&type=script&lang=js&"
export * from "./PriceTest.vue?vue&type=script&lang=js&"
import style0 from "./PriceTest.vue?vue&type=style&index=0&id=8122b2dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8122b2dc",
  null
  
)

export default component.exports